// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as DOMPurify$LiveRoom from "../bindings/DOMPurify.bs.js";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../styles/CommonStyles.bs.js";
import * as SterlingModal$LiveRoom from "../bindings/SterlingModal.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

function LotSymbols$ModalContent(props) {
  var symbolHeight = props.symbolHeight;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.margin2(Css.px(32), Css.px(32)),
                    tl: {
                      hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                            hd: Css.margin2(Css.px(32), Css.px(16)),
                            tl: /* [] */0
                          }),
                      tl: /* [] */0
                    }
                  })
            }, Belt_Array.map(props.lotSymbols, (function (symbol) {
                    var lotSymbolId = symbol.id;
                    return React.createElement("span", {
                                key: symbol.id
                              }, React.createElement("span", {
                                    className: Curry._1(Css.style, {
                                          hd: Css.display("flex"),
                                          tl: {
                                            hd: Css.margin2(Css.px(12), "zero"),
                                            tl: /* [] */0
                                          }
                                        }),
                                    id: "modal-" + lotSymbolId + ""
                                  }, React.createElement("svg", {
                                        key: symbol.id,
                                        role: "presentation",
                                        style: {
                                          verticalAlign: "middle"
                                        },
                                        height: symbolHeight,
                                        width: symbol.width,
                                        fill: "currentColor",
                                        preserveAspectRatio: "xMidYMid meet",
                                        viewBox: "0 0 " + (symbol.width + (" " + symbol.height))
                                      }, React.createElement("g", undefined, React.createElement("path", {
                                                d: symbol.path
                                              }))), React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                                        className: Curry._1(Css.style, {
                                              hd: Css.marginLeft(Css.px(8)),
                                              tl: {
                                                hd: Css.fontSize(Css.px(18)),
                                                tl: {
                                                  hd: Css.lineHeight(Css.px(26)),
                                                  tl: {
                                                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlack_nohashtag)),
                                                    tl: /* [] */0
                                                  }
                                                }
                                              }
                                            }),
                                        children: symbol.name
                                      })), React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                                    children: React.createElement("span", {
                                          dangerouslySetInnerHTML: {
                                            __html: DOMPurify$LiveRoom.sanitize(symbol.description)
                                          }
                                        })
                                  }));
                  })));
}

var ModalContent = {
  make: LotSymbols$ModalContent
};

function LotSymbols(props) {
  var print = props.print;
  var height = props.height;
  var print$1 = print !== undefined ? print : false;
  var match = React.useState(function () {
        return false;
      });
  var setShowModal = match[1];
  var timeoutId = React.useRef(undefined);
  var lotSymbols = Belt_Array.keepMap(props.lotSymbols, (function (lotSymbol) {
          var match = lotSymbol.image;
          if (match === undefined) {
            return ;
          }
          if (typeof match !== "object") {
            return ;
          }
          if (match.NAME !== "LotSymbolSVGImage") {
            return ;
          }
          var image = match.VAL;
          return {
                  id: lotSymbol.lotSymbolId,
                  name: lotSymbol.name,
                  width: String(image.width),
                  height: String(image.height),
                  path: image.path,
                  previouslyKnownAs: lotSymbol.previouslyKnownAs,
                  description: lotSymbol.description
                };
        }));
  var lotSymbolIds = Js_array.joinWith("-", Belt_Array.map(lotSymbols, (function (lotSymbol) {
              return lotSymbol.id;
            })));
  var onClick = React.useCallback((function ($$event) {
          return function (symbolId) {
            $$event.preventDefault();
            Curry._1(setShowModal, (function (param) {
                    return true;
                  }));
            timeoutId.current = Caml_option.some(setTimeout((function (param) {
                        Belt_Option.map(Caml_option.nullable_to_opt(document.getElementById("modal-" + symbolId + "")), (function (element) {
                                element.scrollIntoView({
                                      behavior: "smooth",
                                      block: "start"
                                    });
                              }));
                      }), 100));
          };
        }), [lotSymbolIds]);
  React.useEffect((function () {
          return (function (param) {
                    Belt_Option.map(timeoutId.current, (function (prim) {
                            clearTimeout(prim);
                          }));
                  });
        }), []);
  var match$1 = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement("div", {
              key: lotSymbolIds,
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.flexDirection(print$1 ? "row" : "column"),
                            tl: {
                              hd: Css.flexWrap("wrap"),
                              tl: /* [] */0
                            }
                          }
                        }),
                    tl: {
                      hd: Curry._1(Css.style, print$1 ? /* [] */0 : ({
                                hd: Css.display("grid"),
                                tl: {
                                  hd: Css.gridTemplateColumns({
                                        hd: "maxContent",
                                        tl: {
                                          hd: "auto",
                                          tl: /* [] */0
                                        }
                                      }),
                                  tl: {
                                    hd: Css.rowGap(Css.px(4)),
                                    tl: {
                                      hd: Css.alignItems("flexStart"),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              })),
                      tl: /* [] */0
                    }
                  })
            }, Belt_Array.mapWithIndex(lotSymbols, (function (index, symbol) {
                    var id = String(index) + (symbol.id + (
                        print$1 ? "-print" : ""
                      ));
                    return JsxPPXReactSupport.createElementWithKey(symbol.id, PropSpread$LiveRoom.make, {
                                aria: {
                                  hd: {
                                    TAG: /* LabelledBy */4,
                                    _0: id
                                  },
                                  tl: /* [] */0
                                },
                                children: React.createElement("span", {
                                      className: Curry._1(Css.style, {
                                            hd: Css.margin2(Css.px(2), "zero"),
                                            tl: {
                                              hd: Css.display(print$1 ? "block" : "contents"),
                                              tl: /* [] */0
                                            }
                                          })
                                    }, React.createElement(PropSpread$LiveRoom.make, {
                                          aria: {
                                            hd: {
                                              TAG: /* LabelledBy */4,
                                              _0: id
                                            },
                                            tl: {
                                              hd: {
                                                TAG: /* Hidden */2,
                                                _0: true
                                              },
                                              tl: /* [] */0
                                            }
                                          },
                                          children: React.createElement("svg", {
                                                key: symbol.id,
                                                role: "presentation",
                                                style: {
                                                  verticalAlign: "middle"
                                                },
                                                height: height,
                                                width: symbol.width,
                                                fill: "currentColor",
                                                preserveAspectRatio: "xMidYMid meet",
                                                viewBox: "0 0 " + (symbol.width + (" " + symbol.height))
                                              }, React.createElement("g", undefined, React.createElement("path", {
                                                        d: symbol.path
                                                      })))
                                        }), print$1 ? React.createElement("span", {
                                            className: Curry._1(Css.style, {
                                                  hd: Css.marginRight(Css.px(8)),
                                                  tl: {
                                                    hd: Css.fontSize(Css.pt(8)),
                                                    tl: {
                                                      hd: Css.lineHeight(Css.pt(18)),
                                                      tl: {
                                                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlack_nohashtag)),
                                                        tl: /* [] */0
                                                      }
                                                    }
                                                  }
                                                })
                                          }, symbol.name) : React.createElement("a", {
                                            className: Curry._1(Css.style, {
                                                  hd: Css.marginLeft(Css.px(8)),
                                                  tl: {
                                                    hd: Css.fontSize(Css.px(12)),
                                                    tl: {
                                                      hd: Css.lineHeight(Css.px(18)),
                                                      tl: {
                                                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue60_nohashtag)),
                                                        tl: {
                                                          hd: Css.focus(CommonStyles$LiveRoom.focus),
                                                          tl: /* [] */0
                                                        }
                                                      }
                                                    }
                                                  }
                                                }),
                                            id: id,
                                            href: "#",
                                            onClick: (function ($$event) {
                                                Curry._2(onClick, $$event, symbol.id);
                                              })
                                          }, symbol.name))
                              });
                  })), match[0] ? React.createElement(SterlingModal$LiveRoom.Modal.make, {
                    children: React.createElement(SterlingModal$LiveRoom.Content.make, {
                          children: React.createElement(LotSymbols$ModalContent, {
                                lotSymbols: lotSymbols,
                                symbolHeight: height
                              })
                        }),
                    className: Curry._1(Css.style, {
                          hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                hd: Css.height(Css.pct(100)),
                                tl: {
                                  hd: Css.important(Css.maxHeight(Css.pct(100))),
                                  tl: {
                                    hd: Css.important(Css.maxWidth(Css.pct(100))),
                                    tl: /* [] */0
                                  }
                                }
                              }),
                          tl: /* [] */0
                        }),
                    onClose: (function (param) {
                        Curry._1(setShowModal, (function (param) {
                                return false;
                              }));
                      }),
                    isOpen: true,
                    fixHeader: true,
                    headerTitle: Curry._1(match$1.t, "LotSymbols_symbolDefinitions")
                  }) : null);
}

var make = LotSymbols;

export {
  ModalContent ,
  make ,
}
/* Css Not a pure module */
